import * as React from "react";
import ThrobberImg from "../../assets/throbber.gif";
import { percent, px } from "csx";
import { classes, style } from "typestyle";

interface IThrobber {
  pending: boolean;
  children: React.ReactElement<any>[] | React.ReactElement<any>;
  className?: string;
}

export function Throbber({ pending, children, className }: IThrobber) {
  const imgClasses = classes(throbberImgStyle, !pending && invisibleStyle);
  return (
    <div className={classes(throbberContainerStyle, className)}>
      <img src={ThrobberImg} className={imgClasses} />
      <div className={pending ? invisibleStyle : visibleStyle}>{children}</div>
    </div>
  );
}

const throbberContainerStyle = style({
  position: "relative"
});

const THROBBER_IMG_HEIGHT = 60;
const THROBBER_IMG_WIDTH = 80;

const throbberImgStyle = style({
  position: "absolute",
  height: px(THROBBER_IMG_HEIGHT),

  //center throbber img horizontally
  left: percent(50),
  marginLeft: px(-THROBBER_IMG_WIDTH / 2),

  top: percent(50),
  marginTop: px(-THROBBER_IMG_HEIGHT / 2)
});

const visibleStyle = style({
  visibility: "visible"
});

const invisibleStyle = style({
  visibility: "hidden"
});
